<script setup lang="ts">
const emit = defineEmits(["valueChanged"]);

const props = defineProps<{
    id?: string;
    type?: string;
    value?: string;
    name?: string;
    placeholder?: string;
    bordered?: boolean;
    disabled?: boolean;
    readonly?: boolean;
}>();

const handleInput = (event: Event) => {
    // segurança extra
    if (props.disabled || props.readonly) return;

    emit("valueChanged", (event.target as HTMLInputElement).value);
};
</script>

<template>
    <input
        :type="props.type || 'text'"
        :name="props.name"
        :id="props.id"
        class="text-input"
        :class="[props.bordered ? 'bordered-input' : 'ringed-input']"
        :disabled="props.disabled"
        :readonly="props.readonly"
        @input="handleInput"
        :value="props.value"
        :placeholder="props.placeholder"
    />
</template>
